import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { NodePointer } from "@/components/doc/right-sidebar/node-viewer/NodePointer";
import { NodeColorProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeColorProperty";
import { NodeNameProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeNameProperty";
import { NodeTypeProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeTypeProperty";
import { NodeUnitProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeUnitProperty";
import { NodeValueProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeValueProperty";
import { useNodeTheme } from "@/components/expression/theme";
import { isNodeEditable } from "@/components/tiptap/lock/utils";
import { type ConstantNodeModel } from "@/models/nodes/ConstantNodeModel";

type Props = {
  node: ConstantNodeModel;
  ids: Set<string>;
};

export const NodeConstant = observer(function NodeConstant({ node, ids }: Props) {
  const t = useTranslations("sidebar");
  const theme = useNodeTheme(node);

  return (
    <>
      <NodePointer>
        <NodeTypeProperty node={node} ids={ids} />
      </NodePointer>
      {(isNodeEditable(node) || node.value) && (
        <NodePointer>
          <NodeValueProperty node={node} ids={ids} />
        </NodePointer>
      )}
      {(isNodeEditable(node) || node.name) && (
        <NodePointer>
          <NodeNameProperty node={node} />
        </NodePointer>
      )}
      {node.unitNode && (
        <NodePointer>
          <NodeUnitProperty node={node} />
        </NodePointer>
      )}
      {theme.stroke.type === "colored" && (
        <NodePointer>
          <NodeColorProperty name={t("nodeProps.constantParams.stroke")} node={node} />
        </NodePointer>
      )}
    </>
  );
});
